var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.28571C0 1.91878 1.91878 0 4.28571 0H6.24518C7.47429 0 8.54567 0.83651 8.84378 2.02892L10.4235 8.34776C10.6849 9.39329 10.2942 10.4936 9.43203 11.1403L7.584 12.5263C7.3921 12.6702 7.35038 12.881 7.40429 13.0281C9.02644 17.4564 12.5436 20.9736 16.9719 22.5957C17.119 22.6496 17.3298 22.6079 17.4737 22.416L18.8597 20.568C19.5064 19.7058 20.6067 19.3151 21.6522 19.5765L27.9711 21.1562C29.1635 21.4543 30 22.5257 30 23.7548V25.7143C30 28.0812 28.0812 30 25.7143 30H22.5C10.0736 30 0 19.9264 0 7.5V4.28571Z",
    fill: "#0F1111",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.dc91bf9b1df2e9b37c30a72dca002a8d.svg";
export { ForwardRef as ReactComponent };